import { Container, Accordion, AccordionBody, AccordionHeader, AccordionItem, } from 'reactstrap';
import React, { useState } from 'react';
import styles from './styles.module.scss';

export const ColumnTextWithAccordion = ({
    className,
    content,
    accordionTitle,
    accordionItems,
    titleColour,
}) => {

    const [open, setOpen] = useState('0');
    const toggle = (id) => {
        if (open === id) {
            setOpen();
        } else {
            setOpen(id);
        }
    };

    return (
        <section className={`${styles.root} ${className}`}>
            <Container className="py-4 py-md-5">
                <div className="d-flex gap-5 flex-wrap flex-lg-nowrap">
                    <div className="column" dangerouslySetInnerHTML={{ __html: content }} />
                    <div className="column">
                        {accordionTitle &&
                            <h4 className={`text-${titleColour?.variant}`} style={{color: titleColour?.custom}}>{accordionTitle}</h4>
                        }
                        {accordionItems && accordionItems.length > 0 &&
                            <Accordion open={open} toggle={toggle} flush>
                                {(accordionItems || []).map((item, index) => (
                                    <AccordionItem key={index}>
                                        <AccordionHeader targetId={`${index}`}>
                                            <strong className={`text-${item?.titleColour?.variant}`} style={{color: item?.titleColour?.custom}}>{item?.title}</strong>
                                        </AccordionHeader>
                                        <AccordionBody accordionId={`${index}`}>
                                            <div dangerouslySetInnerHTML={{ __html: item?.content }} />
                                        </AccordionBody>
                                    </AccordionItem>
                                ))}
                            </Accordion>
                        }
                    </div>
                </div>
            </Container>
        </section>
    )
}

export default ColumnTextWithAccordion;
